import CTAButton from '@/components/shared/CTAButton'

const LenderFactsSection = ({ lenderName }) => {
  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: '#ffdcc5' }}>
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground mb-6 text-3xl font-bold">
          Facts About {lenderName} and UK Car Finance Mis-Selling
        </h2>

        <p className="mb-6 text-lg leading-relaxed">
          Millions of drivers across the UK may be entitled to compensation due
          to mis-sold car finance agreements, with many involving lenders such
          as {lenderName}. According to the Financial Conduct Authority (FCA),
          approximately <span className="font-raleway-numbers">95%</span> of car
          finance deals included commission payments between lenders and
          dealerships, often without the customer&apos;s knowledge. Alarmingly,
          up to <span className="font-raleway-numbers">44%</span>
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>4</sup> of
          these agreements may have been mis-sold, meaning many drivers
          unknowingly paid more than necessary.
        </p>

        <p className="mb-6 text-lg leading-relaxed">
          If you financed a vehicle after{' '}
          <span className="font-raleway-numbers">2007</span> using a Personal
          Contract Purchase (PCP), Hire Purchase (HP), lease purchase, or a
          personal loan arranged through a dealership, you may be eligible to
          claim. This applies to both new and used vehicles including cars,
          vans, motorcycles and trucks.
        </p>

        <p
          className="mb-6 text-lg leading-relaxed"
          style={{ color: 'oklch(0.2205 0.0376 194.77)' }}
        >
          Compensation can vary based on your specific agreement. While some
          reports suggest potential payouts in the thousands, the FCA has stated
          that, on average, drivers could receive around £
          <span className="font-raleway-numbers">829</span>
          <sup style={{ fontSize: '0.5em', verticalAlign: 'super' }}>2</sup> per
          claim. A recent Supreme Court ruling and an FCA investigation have
          confirmed this is a widespread issue, paving the way for mass claims
          across the country.
        </p>

        <p className="mb-8 text-lg leading-relaxed">
          If you suspect you were mis-sold a {lenderName} finance agreement, now
          is the time to check your eligibility. With millions potentially
          affected and action already underway, reclaiming what you&apos;re owed
          could be easier than you think.
        </p>

        <div className="text-center">
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

export default LenderFactsSection
